<div class="sk-table" [class.sk-table--framed]="framed" role="status" aria-label="Loading"
  [style.--sk-cols]="gridDesktop" [style.--sk-cols-m]="gridMobile">

  <div class="sk-row sk-head" *ngIf="framed" aria-hidden="true">
    <div class="sk-cell" *ngFor="let col of columns" [class.sk-hide-m]="col.hideOnMobile"
      [class.sk-end]="col.align === 'end'" [class.sk-center]="col.align === 'center' || col.kind === 'check'">
      <span class="sk sk-box sk-box--head" *ngIf="col.kind === 'check'"></span>
      <ng-container *ngIf="col.kind !== 'check'">{{ col.label }}</ng-container>
    </div>
  </div>

  <div class="sk-row sk-body-row" *ngFor="let r of rowIndexes; trackBy: trackByIndex" aria-hidden="true"
    [style.animation-delay.ms]="r * 70">
    <div class="sk-cell" *ngFor="let col of columns" [ngSwitch]="col.kind" [class.sk-hide-m]="col.hideOnMobile"
      [class.sk-end]="col.align === 'end' || col.kind === 'amount'"
      [class.sk-center]="col.align === 'center' || col.kind === 'check' || col.kind === 'icon'">

      <span *ngSwitchCase="'check'" class="sk sk-box"></span>

      <ng-container *ngSwitchCase="'entity'">
        <span class="sk sk-logo"></span>
        <span class="sk-stack">
          <span class="sk sk-title" [style.width.%]="titleWidths[r % 8]"></span>
          <span class="sk sk-sub" [style.width.%]="subWidths[r % 8]"></span>
        </span>
      </ng-container>

      <span *ngSwitchCase="'title'" class="sk-stack">
        <span class="sk sk-title" [style.width.%]="titleWidths[r % 8]"></span>
        <span class="sk sk-sub" [style.width.%]="subWidths[r % 8]"></span>
      </span>

      <span *ngSwitchCase="'text'" class="sk sk-text" [style.width.%]="textWidths[r % 8]"></span>
      <span *ngSwitchCase="'date'" class="sk sk-date"></span>
      <span *ngSwitchCase="'pill'" class="sk sk-pill"></span>
      <span *ngSwitchCase="'amount'" class="sk sk-amount" [style.width.px]="56 + (r % 3) * 12"></span>
      <ng-container *ngSwitchCase="'avatar'">
        <span class="sk sk-avatar"></span>
        <span class="sk sk-date"></span>
      </ng-container>
      <span *ngSwitchCase="'icon'" class="sk sk-icon"></span>
    </div>
  </div>
</div>
